import { render, staticRenderFns } from "./Busca.vue?vue&type=template&id=e0a7c2d6&scoped=true&lang=pug"
import script from "./Busca.vue?vue&type=script&lang=js"
export * from "./Busca.vue?vue&type=script&lang=js"
import style0 from "./Busca.styl?vue&type=style&index=0&id=e0a7c2d6&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a7c2d6",
  null
  
)

export default component.exports